var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[(_vm.activeName=='basic')?_c('Basic'):_vm._e(),_vm._v(" "),(_vm.activeName=='appconfig')?_c('AppConfig'):_vm._e(),_vm._v(" "),(_vm.activeName=='share')?_c('Share'):_vm._e(),_vm._v(" "),(_vm.activeName=='update')?_c('Update'):_vm._e(),_vm._v(" "),(_vm.activeName=='splash')?_c('Splash'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d26203b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/appsetting/appopen/event.vue
// module id = null
// module chunks = 